import Annotations from '../components/annotation/Annotations'
import AnnotationForm from '../components/annotation/AnnotationForm'
import ActivityLogs from '../components/ActivityLogs'
import ReportIssueForm from '../components/ReportIssueForm'

export default {
	components: {
		Annotations,
		ActivityLogs,
		ReportIssueForm,
	},
	data () {
		return {
			viewer: null,
			activeTab: 'general',
			wikidataSearchFlag: false,
			annotationFormFlag: false,
			annotationSelected: {},
		}
	},
	computed: {
		annotationFormComponent() {
			return AnnotationForm;
		}
	},
	created() {
		document.addEventListener('keyup', this.eventHandler);
    },
	mounted() {
		// Initially display the image when the modal is opened.
		this.openseadragon();
	},
	updated() {
		// Update the image when 'Prev' or 'Next' option is selected.
		if(this.$refs['osd'].childElementCount == 0) {
			this.openseadragon();
		}
	},
	methods: {
		onAnnotationSelected(annotation) {
			this.annotationSelected = annotation;
			this.annotationFormFlag = true;
		},
		hideWikidataSearch() {
			this.wikidataSearchFlag = false;
		},
		resetData() {
			this.wikidataSearchFlag = false;
			this.annotationFormFlag = false;
			this.annotationSelected = {}
			this.destroyOpenseadragon();
		},
		configureOpenseadragon() {
			if(this.viewer !== null) {
				// Disabling shortcut keys.
				this.viewer.innerTracker.keyHandler = null;
				
				// Disabling zoom on click.
				this.viewer.gestureSettingsMouse.clickToZoom = false;
			}
		},
		destroyOpenseadragon() {
			if (this.viewer !== null) {
				this.viewer.destroy();
			}
		},
		hasPrev(canvasId) {
			var $prev = this.current(canvasId).prev();
			return $prev.length > 0 ? $prev : null;
		},
		prev(canvasId) {
			var $prev = this.hasPrev(canvasId);
			
			if($prev !== null) {
				var prevCanvasId = $prev.data('canvas-id');
				this.getCanvasById(prevCanvasId);
			}
			
			this.resetData();
		},
		hasNext(canvasId) {
			var $next = this.current(canvasId).next();
			return $next.length > 0 ? $next : null;
		},
		next(canvasId) {
			var $next = this.hasNext(canvasId);
			
			if($next !== null) {
				var nextCanvasId = $next.data('canvas-id');
				this.getCanvasById(nextCanvasId);
			}
			
			this.resetData();
		},
		getCanvasById(id) {
			this.$store.dispatch('GET_CANVAS', {'id': id});
		},
		current(canvasId) {
			return $('article.image-result[data-canvas-id="' + canvasId + '"]');
		},
		eventHandler(event) {
			// If no other dialog/modal is open, handle the 'Esc' key event.
			if (document.getElementsByClassName('modal-dialog').length == 0 && event.keyCode === 27) {
				this.close();
			}
		},
		close() {
			// Display confirmation message if annotation form is open and has 'transcription' or 'tags' entered.
			if(this.annotationFormFlag && typeof this.$refs.annotationForm !== 'undefined'
				&& (this.$refs.annotationForm.annotation.transcription !== ''
					|| this.$refs.annotationForm.annotation.tags.length > 0)) {
				
				// Remove event listener while displaying the confirmation message.
				// So that, the confirmation message won't be displayed multiple times
				// if 'Esc' is clicked again while it's being displayed.
				document.removeEventListener('keyup', this.eventHandler);
				
        		this.$bvModal.msgBoxConfirm(this.__('translations.message.close_modal_without_saving'), {
    				okTitle: this.__('translations.button.yes'),
    				cancelTitle: this.__('translations.button.no'),
    				centered: true,
    				noCloseOnBackdrop: true,
    			}).then(confirmed => {
    				if(confirmed) {
    					this.$emit('close');
    				} else {
    					// Add the event back. So that, it can keep listening.
    					document.addEventListener('keyup', this.eventHandler);
    				}
    			}).catch(err => {
    				// An error occurred
    			})
        	} else {
        		this.$emit('close');
        	}
		}
	},
	beforeDestroy() {
		this.destroyOpenseadragon();
		document.removeEventListener('keyup', this.eventHandler);
	}
}